import Chip from '@mui/material/Chip';
import { BsSpeedometer } from "react-icons/bs";

const Stat = props => {
    const { value } = props
  
    return (
        <Chip icon={<BsSpeedometer size={14}/>} label={value} size="small" sx={{paddingX: '1rem'}} />
    )
}
  
export default Stat